import { render, staticRenderFns } from "./re-exam-and-re-learn.vue?vue&type=template&id=58fd1143"
import script from "./re-exam-and-re-learn.vue?vue&type=script&lang=js"
export * from "./re-exam-and-re-learn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports